module.exports = __webpack_public_path__ + "img/button-dental.3f1b1caa.png";